module.exports = __webpack_public_path__ + "img/dashtech-symbol.0020fd58.svg";